import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { AuthProvider } from './context/AuthContext';
import './utils/debugAuth'; // TRACK ALL AUTH OPERATIONS
import { UserProvider } from './context/UserContext';
import { validateConfig } from './config/constants';
import { logEnvironmentStatus } from './utils/envChecker';

// Import authentication retry helpers - DISABLED to prevent infinite timeout loops
// import './utils/authRetryHelper';
// import './utils/injectTimeoutRetry';

// Import axios configuration
import './config/axiosConfig';

import "./index.css";

// Validate configuration at app bootstrap
validateConfig();

// Log environment variables status to console
logEnvironmentStatus();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true
      }}
    >
      <AuthProvider>
        <UserProvider>
          <App />
        </UserProvider>
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);
